import React, { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { InputGroup, Input, Button } from "reactstrap";
import axios from "axios";
import { useContext } from "react";
import DataTable from "components/DataTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import ClearIcon from "components/Images/clearIcon";
import { AppContext } from "components/AppContext";

const Accounts = () => {
  const { config, StoreAPIDefaults, signOut } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [currentPaginationProps, setCurrentPaginationProps] = useState(null);
  const [paginationToken, setPaginationToken] = useState(
    "eyJvZmZzZXQiOiAwLCAibGltaXQiOiAxMDAsICJvcmRlcmJ5IjogWyJhY2NvdW50aWQiXX0="
  );
  const [searchTerm, setSearchTerm] = useState(undefined);
  const [filterConfig, setFilterConfig] = useState(null);
  const history = useHistory();

  const settings = {
    expanded: "",
    sortBy: [
      {
        id: "sortname",
        desc: false
      }
    ],
    globalFilter: "",
    hiddenColumns: ["id"]
  };

  const columns = useMemo(
    () => [
      {
        accessor: "id",
        disableSortBy: true
      },
      {
        Header: "Account Name",
        accessor: "name",
        Cell: ({ row }) => {
          return (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push(`/app/account/${row.values.id}`);
                const selectedAccount = {
                  id: row.values.id,
                  name: row.values.name
                };
                localStorage.setItem(
                  "accountDeatils",
                  JSON.stringify(selectedAccount)
                );
              }}
            >
              {row.values.name}
            </div>
          );
        }
      },
      {
        Header: "AO Key",
        accessor: "aokey",
        Cell: ({ row }) => {
          return (
            <div
              style={{
                width: 100,
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden"
              }}
              title={row.values.aokey}
            >
              {row.values.aokey}
            </div>
          );
        }
      }
    ],
    []
  );
  const data = useMemo(
    () =>
      accounts
        ?.filter(item => item.isdeleted === 0)
        .map(item => {
          const { accountid, accountname, accountaokeys } = item;
          return {
            id: accountid,
            name: accountname,
            aokey: accountaokeys.length != undefined && accountaokeys?.join(",")
          };
        }),
    [accounts]
  );

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${config.configApiBaseUrl}/accounts`, {
        headers: {
          Authorization: `Bearer ${StoreAPIDefaults.accessToken}`
        },
        params: {
          paginationtoken: paginationToken,
          ...(filterConfig && {
            filters: filterConfig
          })
        }
      })
      .then(response => {
        setLoading(false);
        setAccounts(response.data.data);
        setPaginationToken(response.data.data.paginationtoken);
        if (currentPaginationProps) {
          setTimeout(() => {
            currentPaginationProps.gotoPage(currentPaginationProps.pageIndex);
          }, 0);
        }
      })
      .catch(err => {
        console.log(err);
        if (err?.response?.status === 401) {
          signOut();
        } else {
          history.push({
            pathname: "/app/errordisplay",
            state: {
              error: err
            }
          });
        }
        setLoading(false);
        setError(err);
      });
  }, [paginationToken, filterConfig]);

  const getMoreAccounts = ({ pageIndex, gotoPage }) => {
    setCurrentPaginationProps({ pageIndex, gotoPage });
  };
  const resetReportsGrid = () => {
    setPaginationToken(
      "eyJvZmZzZXQiOiAwLCAibGltaXQiOiAxMDAsICJvcmRlcmJ5IjogWyJhY2NvdW50aWQiXX0="
    );
    setAccounts([]);
  };

  const handleClear = () => {
    setSearchTerm(undefined);
    resetReportsGrid();
    setFilterConfig(null);
  };

  const handleFilter = () => {
    resetReportsGrid();
    let payload = {};
    if (searchTerm.length >= 0) {
      payload.accountname = {
        ilk: searchTerm
      };
    }

    const filtertoken = btoa(
      JSON.stringify([
        {
          and: [payload]
        }
      ])
    );

    setFilterConfig(filtertoken);
  };

  return (
    <div
      className="page page--centered"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div className="my-5">
        <header>
          <h1>Please select an account</h1>
        </header>
        <hr />
      </div>
      <InputGroup size="small" style={{ width: "30%", marginBottom: "3rem" }}>
        <Input
          value={searchTerm || ""}
          onChange={e => {
            setSearchTerm(e.target.value);
          }}
          size="small"
          placeholder="Search by Account Name"
          onKeyPress={event => event.key === "Enter" && handleFilter()}
        />

        {searchTerm?.length >= 0 && (
          <Button
            style={{
              color: "#0B78D0",
              backgroundColor: "#FFF",
              border: "1px solid #ced4da"
            }}
            className="btn-secondary"
            onClick={handleClear}
          >
            <ClearIcon />
          </Button>
        )}
        <Button
          className="btn-primary"
          style={{ backgroundColor: "#0B78D0" }}
          onClick={handleFilter}
        >
          <FontAwesomeIcon icon={faSearch} />
        </Button>
      </InputGroup>
      {loading && <div className="my-5 p-5 text-center">Loading...</div>}

      {!loading && (
        <>
          <div style={{ maxWidth: "70%" }}>
            <DataTable
              columns={columns}
              data={data}
              options={settings}
              onLastPage={getMoreAccounts}
              displayTimeFormatMessage
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Accounts;
